export function deferredPromise(initFn?: (...args: unknown[]) => void) {
  let resFn: Function, rejFn: Function;
  const promise = new Promise((res, rej) => {
    resFn = res;
    rejFn = rej;
    try {
      initFn?.();
    } catch (error) {
      rej(error);
    }
  });

  return {
    promise,
    res: resFn,
    rej: rejFn,
  };
}
